import { __awaiter } from './_virtual/_tslib.js';
import React, { useState, useEffect } from 'react';
import { Button, Link, BasicResponsiveImage } from '@vp/swan';
import { IdMeEndpoint } from './Constants.js';
import { useSignInContext } from './SignInContext.js';

const loginWindowWidth = 500;
const images = {
    "en-us": "https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto,w_400/jfavaloro_test/Misc-test/idme-verify-english.svg",
    "es-us": "https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto/jfavaloro_test/Misc-test/idme-verify-spanish.svg"
};
const SignInButton = () => {
    const { setIsVerified, trackVerificationClick, locale, customerId } = useSignInContext();
    const [loginWindow, setLoginWindow] = useState(null);
    const [loginWindowUrl, setLoginWindowUrl] = useState('');
    const openIdMeLoginWindow = () => {
        const loginWindow = window.open(IdMeEndpoint(window.origin, locale.split('-')[0].toLocaleLowerCase()), "IdMeLogin", `width=${loginWindowWidth},height=${window.innerHeight - 50},left=${(window.innerWidth / 2) - (loginWindowWidth / 2)},top=50`);
        setLoginWindow(loginWindow);
        const interval = setInterval(() => {
            var _a;
            if (loginWindow === null || loginWindow === void 0 ? void 0 : loginWindow.closed) {
                clearInterval(interval);
            }
            try {
                setLoginWindowUrl(((_a = loginWindow === null || loginWindow === void 0 ? void 0 : loginWindow.location) === null || _a === void 0 ? void 0 : _a.href) || '');
            }
            catch (e) {
            }
        }, 500);
    };
    useEffect(() => {
        const verifyUser = (code, customerId) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch(`https://idme.prod.merch.vpsvc.com/verify/${code}/${customerId}?redirectUrl=${encodeURI(window.origin)}`).then(response => response.json());
            setIsVerified(response.isVerified);
        });
        const verifyUserWithError = (error, customerId) => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield fetch(`https://idme.prod.merch.vpsvc.com/verifyWithError/${error}/${customerId}`).then(response => response.json());
            setIsVerified(response.isVerified);
        });
        if (loginWindow
            && loginWindow.location
            && loginWindow.location.search) {
            const searchParams = new URLSearchParams(loginWindow.location.search);
            if (searchParams.get("code")) {
                const code = searchParams.get("code") || "";
                verifyUser(code, customerId);
            }
            else if (searchParams.get("error")) {
                const error = searchParams.get("error") || "";
                verifyUserWithError(error, customerId);
            }
            loginWindow.close();
        }
    }, [loginWindowUrl, customerId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { render: props => (React.createElement(Link, { onClick: () => {
                    trackVerificationClick();
                    openIdMeLoginWindow();
                }, width: "full-width" },
                React.createElement(BasicResponsiveImage, { aspectRatio: 0.2, alt: "verify military status button", src: images[locale.toLocaleLowerCase()] }))) })));
};

export { SignInButton as default };
//# sourceMappingURL=SignIn.js.map
